import { useState } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { API } from "../data/site";
import { SEO } from "@/components/Seo";

export default function AdminLogin() {
  const [form, setForm] = useState({ email: "", password: "" });
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");
    try {
      const { data } = await axios.post(`${API}/auth/login`, form);
      localStorage.setItem("pk_admin_token", data.token);
      navigate("/admin/dashboard");
    } catch (err) {
      const d = err?.response?.data?.detail;
      setError(typeof d === "string" ? d : "Login failed. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  const inputCls =
    "w-full bg-paper-card border border-[#D6CEBF] rounded-xl px-4 py-3 text-ink placeholder:text-ink-muted focus:outline-none focus:ring-2 focus:ring-turmeric/70 text-sm";

  return (
    <div data-testid="admin-login-page" className="min-h-[80vh] flex items-center justify-center px-4 pt-24 pb-16">
      <SEO title="Kitchen Office | Pranivaa Kitchens" description="Admin sign in." path="/admin" noindex />
      <div className="w-full max-w-md bg-paper-card border border-[#E7E2D7] rounded-3xl p-8 md:p-10 shadow-lg">
        <img loading="lazy" decoding="async" src="/logo.png" alt="Pranivaa Kitchens logo" className="w-16 h-16 rounded-full object-cover shadow-md mb-5" />
        <h1 className="font-serif text-3xl font-semibold text-ink mb-2">Kitchen Office</h1>
        <p className="text-sm text-ink-soft mb-8">Sign in to view and export your waitlist leads.</p>
        <form onSubmit={submit} className="space-y-4" data-testid="admin-login-form">
          <input
            data-testid="admin-email-input"
            className={inputCls}
            type="email"
            required
            placeholder="Admin email"
            value={form.email}
            onChange={(e) => setForm({ ...form, email: e.target.value })}
          />
          <input
            data-testid="admin-password-input"
            className={inputCls}
            type="password"
            required
            placeholder="Password"
            value={form.password}
            onChange={(e) => setForm({ ...form, password: e.target.value })}
          />
          {error && (
            <p data-testid="admin-login-error" className="text-sm text-beet font-medium">{error}</p>
          )}
          <button
            data-testid="admin-login-button"
            type="submit"
            disabled={loading}
            className="w-full rounded-full bg-beet text-white font-bold text-sm px-6 py-4 transition-all duration-300 hover:bg-beet-deep disabled:opacity-60"
          >
            {loading ? "Signing in..." : "Sign In"}
          </button>
        </form>
      </div>
    </div>
  );
}
